<template>
  <div>
    <el-table
      :data="data"
      style="width: 100%"
      size="medium"
      header-row-class-name="supervision-table-header"
      row-class-name="common-table-row"
      class="is-print-hide common-table"
      border
    >
      <el-table-column label="通用名" prop="drugName"></el-table-column>
      <el-table-column label="规格" prop="drugSpec"></el-table-column>
      <el-table-column label="数量" prop="drugNum">
        <template #default="{ row: { drugNum, drugUnit } }">
          <span>{{ `${drugNum || ''}${drugUnit || ''}` }}</span>
        </template>
      </el-table-column>

      <el-table-column label="生产厂家" prop="drugManufacturer"></el-table-column>
      <el-table-column label="条形码" prop="barCode"></el-table-column>
      <el-table-column label="批准文号" prop="approvalNumber"></el-table-column>
      <el-table-column label="生产批号" prop="drugProductBatchNo"></el-table-column>
      <el-table-column label="分类" :width="100">
        <template #default="{ row: { drugVariety } }">
          {{ drugVariety | adaptDrugVariety }}
        </template>
      </el-table-column>
      <el-table-column label="是否处方药" :min-width="100">
        <template #default="{ row: { isPrescription } }">
          {{ isPrescription | formatPrescription }}
        </template>
      </el-table-column>
      <el-table-column label="储藏条件" prop="storageCondition"></el-table-column>
      <el-table-column label="有效期至" :width="100">
        <template #default="{ row: { drugValidityPeriod } }">
          {{ drugValidityPeriod | formatDate }}
        </template>
      </el-table-column>
      <el-table-column prop="storeContactsName" label="效期状态" :width="80">
        <template #default="{ row: { periodStatus } }">
          <span :class="{ red: periodStatus === 2, green: periodStatus === 0, yellow: periodStatus === 1 }">
            {{ periodStatus | adaptStatus }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="库存更新时间" :width="160">
        <template #default="{ row: { stockTime } }">
          {{ stockTime | formatTime }}
        </template>
      </el-table-column>
      <el-table-column label="供应商详情" prop="supplierName" width="100">
        <template #default="{ row }">
          <el-button
            type="text"
            @click="
              gridTableData = [row];
              dialogTableVisible = true;
            "
          >
            查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="供应商详情" :visible.sync="dialogTableVisible" center width="880px" alignFooter="right">
      <div style="padding-bottom: 40px">
        <el-table :data="gridTableData" border>
          <el-table-column property="supplierName" width="160px" label="供应商名称"></el-table-column>
          <el-table-column property="supplierCreditCode" width="160px" label="统一组织机构代码证号"></el-table-column>
          <el-table-column
            property="supplierDrugLicense"
            width="200px"
            label="供应商药品经营许可证编号"
          ></el-table-column>
          <el-table-column property="supplierBusinessScope" width="190px" label="供应商经营范围"></el-table-column>
          <el-table-column property="supplierLegalPerson" width="120px" label="供应商法人"></el-table-column>
          <el-table-column property="supplierAddress" width="160px" label="供应商地址"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'supervisionList',
  props: {
    type: {
      type: String
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      gridTableData: [],
      dialogTableVisible: false
    };
  },
  filters: {
    formatTime(val) {
      if (!val) return '--';
      return dayjs(val).format('YYYY-MM-DD HH:mm:ss');
    },
    formatDate(val) {
      if (!val) return '--';
      return dayjs(val).format('YYYY-MM-DD');
    },
    formatPrescription(val) {
      return val === 1 ? '处方药' : val === 0 ? '非处方药' : '--';
    },
    adaptDrugVariety(val) {
      const statusMap = {
        YBYP: '一般药品',
        BJSP: '食品保健品',
        ZYYP: '中药饮片',
        ZYC: '中药材',
        YLQX: '医疗器械',
        YYHC: '医用耗材',
        QT: '其他'
      };
      return statusMap[val];
    },
    adaptStatus(val) {
      const statusMap = { 1: '近效期', 0: '正常', 2: '过期' };
      return statusMap[val];
    }
  }
};
</script>

<style lang="scss" scoped>
.drug-item {
  position: relative;
  padding: 5px 0;

  .drug-title {
    font-weight: 500;
  }

  &:before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background-color: #efefef;
  }

  &:last-child {
    &:before {
      display: none;
    }
  }
}

.red {
  color: #eb3c36;
}

.green {
  color: green;
}

.yellow {
  color: #ebb436;
}
</style>
